import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

import { TransmissionReportHistoryResponse } from '@/types/transmissionHistory';

export const transmissionHistoryApiSlice = createApi({
  reducerPath: 'transmissionHistoryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.TransmissionHistory],
  endpoints: (builder) => ({
    getTransmissionHistory: builder.query<
      TransmissionReportHistoryResponse,
      {
        transmissionReportId: string;
        patientId: string;
        signedDate: string;
      }
    >({
      query: ({ transmissionReportId, patientId, signedDate }) => ({
        url: `/history/${transmissionReportId}/${patientId}/${signedDate}/report-history`,
        method: 'GET'
      }),
      providesTags: (_result, _error, arg) => [
        { type: API_SLICE.TransmissionHistory, id: arg.transmissionReportId }
      ]
    })
  })
});

export const { useGetTransmissionHistoryQuery } = transmissionHistoryApiSlice;
